package devxertech.com

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import devxertech.com.component.CustomStyles
import devxertech.com.seo.SiteOrganizationJsonLd
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Main


@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        CustomStyles()
        SiteOrganizationJsonLd()
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            Main(attrs = { id("main-content"); style { property("width", "100%") } }) {
                content()
            }
        }
    }
}
